var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-checkbox-input',{attrs:{"label":_vm.filter.text,"name":_vm.fKey,"value":_vm.filter.value,"tooltip":_vm.filter.tooltip},on:{"change":function($event){return _vm.$emit('set-filter', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }